export const outcomeData = {
  buttons: [
    {
      label: "I'm waiting for a decision",
      id: 'waiting',
    },
    {
      label: 'I have been told by my bank I will receive all of my money back',
      id: 'all-money-back',
    },
    {
      label: 'I have been told by my bank I will receive some of my money back',
      id: 'some-money-back',
    },
    {
      label: 'I have been told by my bank I will not receive my money back',
      id: 'no-money-back',
    },
  ],
  title: 'What was the outcome?',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/5e64c8f9579d-tooliconquestion.jpg',
  },
}
